import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CoreDeploymentQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ICoreDeploymentOverview } from "../../models/CoreDeployment/CoreDeploymentRun";

/** A run's AI overview, polled every 10 s while the worker is still writing it. */
export default function useCoreDeploymentOverview(runId?: string | null) {
  const { get } = useApiHelper();

  const overview = useQuery({
    queryKey: CoreDeploymentQueryKeys.overview(runId ?? ""),
    enabled: !!runId,
    queryFn: () =>
      get<IDefaultResponse<ICoreDeploymentOverview>>(`/core-deployments/${runId}/overview`).then(
        (res) => res.data,
      ),
    refetchInterval: (query) => (query.state.data?.status === "Pending" ? 10000 : false),
  });

  return { overview };
}
